import moment from 'moment';

export function dateObjectToDateString(date: Date): string {
    return `${date.getFullYear()
    }-${((date.getMonth() + 1) >= 10) ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
    }-${((date.getDate()) >= 10) ? (date.getDate()) : '0' + (date.getDate())}`;
}

export function dateObjectToTimeString(date: Date): string {
    return `${((date.getHours()) >= 10) ? (date.getHours()) : '0' + (date.getHours())
        }:${((date.getMinutes()) >= 10) ? (date.getMinutes()) : '0' + (date.getMinutes())}`;
}

export function dateObjectFromDateTimeStrings(dateString: string, timeString: string | null | undefined): Date {
    if ( timeString === undefined || timeString === null || timeString.length < 4) {
        return moment(dateString).toDate();
    } else {
        return moment(`${dateString} ${timeString}`, 'YYYY-MM-DD HH:mm').toDate();
    }
}

export function  dateTwoDigitYearFormatter(value: string, event: any): string {
    if (undefined !== value && null !== value && value.length > 0) {
        if (moment(value).isValid() && moment(value).year() < 100) {
            const newDate = moment(value);
            newDate.year(newDate.year() + 2000);
            return newDate.format('YYYY-MM-DD');
        } else {
            return value;
        }
    } else {
        return value;
    }
}
